/**
 * Blog FAQ - Accordion & Category Filter
 */
document.addEventListener('DOMContentLoaded', function () {
  'use strict';

  var section = document.querySelector('.blog-faq');
  if (!section) return;

  var items = section.querySelectorAll('.blog-faq__item');
  var catBtns = section.querySelectorAll('.blog-faq__cat-btn');

  // Accordion
  items.forEach(function (item) {
    var btn = item.querySelector('.blog-faq__question');
    var answer = item.querySelector('.blog-faq__answer');

    if (!btn || !answer) return;

    btn.addEventListener('click', function () {
      var isOpen = item.classList.contains('blog-faq__item--open');

      // Close all
      items.forEach(function (i) {
        i.classList.remove('blog-faq__item--open');
        var a = i.querySelector('.blog-faq__answer');
        var b = i.querySelector('.blog-faq__question');
        if (a) a.hidden = true;
        if (b) b.setAttribute('aria-expanded', 'false');
      });

      // Open clicked
      if (!isOpen) {
        item.classList.add('blog-faq__item--open');
        answer.hidden = false;
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  // Category filter
  catBtns.forEach(function (catBtn) {
    catBtn.addEventListener('click', function () {
      // Update active state
      catBtns.forEach(function (b) { b.classList.remove('blog-faq__cat-btn--active'); });
      catBtn.classList.add('blog-faq__cat-btn--active');

      var category = catBtn.getAttribute('data-faq-cat');

      // Filter items
      var visibleCount = 0;
      items.forEach(function (item) {
        var itemCat = item.getAttribute('data-category');
        if (category === 'all' || itemCat === category) {
          item.classList.remove('blog-faq__item--hidden');
          item.style.display = '';
          visibleCount++;
        } else {
          item.classList.add('blog-faq__item--hidden');
          item.style.display = 'none';
          item.classList.remove('blog-faq__item--open');
          var a = item.querySelector('.blog-faq__answer');
          if (a) a.hidden = true;
        }
      });
    });
  });
});
